import type { XpaSupportedComponentsResolverProps } from "@/components/xpa-layout/XpaLayout";
import { XpaLayout } from "@/components/xpa-layout/XpaLayout";
import {
  StreamName,
  useRegisterStream,
  useRegisterXpaStream,
} from "@/modules/analytics";
import type { Layout } from "@motain/xpa-proto-files-web/lib/types/xpa";
import type { GetServerSideProps, InferGetServerSidePropsType } from "next";

import styles from "@/styles/pages/Directory.module.scss";
import type { FC } from "react";
import { SectionHeader } from "@/xpa-components/section-header/SectionHeader";
import { fetchXpaLayoutWithResponseInfo } from "@/utils/fetchXpaLayout";
import { SimplePagination } from "@/xpa-components/simple-pagination/SimplePagination";
import { HorizontalSeparator } from "@/xpa-components/horizontal-separator/HorizontalSeparator";
import { NavigationBreadCrumbs } from "@/xpa-components/navigation-breadcrumbs/NavigationBreadCrumbs";
import { DirectoryExpandedList } from "@/xpa-components/directory-expanded-list/DirectoryExpandedList";

const Directory: FC<InferGetServerSidePropsType<typeof getServerSideProps>> = (
  props,
) => {
  useRegisterStream(StreamName.DirectoryAllTeamsStream);
  useRegisterXpaStream(props);

  return (
    <div className={styles.xpaContainer}>
      <XpaLayout
        layout={props}
        XpaSupportedComponentsResolver={XpaSupportedComponentsResolver}
      />
    </div>
  );
};

export const getServerSideProps: GetServerSideProps<Layout> = async (ctx) => {
  const layoutResponse = await fetchXpaLayoutWithResponseInfo(ctx);

  if (layoutResponse.status === 404) {
    return { notFound: true };
  } else {
    return { props: layoutResponse.layout };
  }
};

export default Directory;

const XpaSupportedComponentsResolver: XpaSupportedComponentsResolverProps = ({
  contentType,
}) => {
  switch (contentType.$case) {
    case "navigationBreadcrumbs":
      return <NavigationBreadCrumbs {...contentType.navigationBreadcrumbs} />;
    case "sectionHeader":
      return <SectionHeader {...contentType.sectionHeader} />;
    case "directoryExpandedList":
      return <DirectoryExpandedList {...contentType.directoryExpandedList} />;
    case "horizontalSeparator":
      return <HorizontalSeparator {...contentType.horizontalSeparator} />;
    case "simplePagination":
      return <SimplePagination {...contentType.simplePagination} />;
    default:
      return null;
  }
};
